import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { AuthenticationListItemProps } from "@/types";
import { TextButton, FlexBox, Icon, ListItem } from "@/components/common";


/**
 * Displays a list item & buttons for authenticating an integration.
 */
const __default__ = {
  name: "AuthenticationListItem",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    hasCredentials: { type: Boolean },
    loading: { type: Boolean },
    inactive: { type: Boolean }
  },
  emits: ["click", "connect", "disconnect"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const color = computed(() => (props.hasCredentials ? "positive" : "grey"));
const clickable = computed(() => !props.inactive && props.hasCredentials);

return (_ctx: any,_cache: any) => {
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!

  return (_openBlock(), _createBlock(_unref(ListItem), {
    clickable: clickable.value,
    color: color.value,
    title: props.title,
    subtitle: props.hasCredentials ? 'Connected' : 'Not Connected',
    onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('click')))
  }, {
    icon: _withCtx(() => [
      (!props.loading)
        ? (_openBlock(), _createBlock(_unref(Icon), {
            key: 0,
            color: color.value,
            variant: "integrate",
            size: "sm"
          }, null, 8, ["color"]))
        : (_openBlock(), _createBlock(_component_q_circular_progress, {
            key: 1,
            indeterminate: ""
          }))
    ]),
    actions: _withCtx(() => [
      _createVNode(_unref(FlexBox), {
        "full-width": "",
        justify: "end"
      }, {
        default: _withCtx(() => [
          (!props.hasCredentials)
            ? (_openBlock(), _createBlock(_unref(TextButton), {
                key: 0,
                label: "Connect",
                color: "primary",
                outlined: "",
                icon: "integrate",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('connect')))
              }))
            : (!clickable.value)
              ? (_openBlock(), _createBlock(_unref(FlexBox), {
                  key: 1,
                  column: "",
                  align: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TextButton), {
                      outlined: "",
                      label: "Edit permissions",
                      icon: "edit",
                      b: "2",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('connect')))
                    }),
                    _createVNode(_unref(TextButton), {
                      outlined: "",
                      label: "Disconnect",
                      icon: "delete",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('disconnect')))
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["clickable", "color", "title", "subtitle"]))
}
}

})